import { arrayMove } from "@dnd-kit/sortable";

function getBaseSlideId(slide, index) {
  if (slide?.slideId) {
    return `slide:${slide.slideId}`;
  }
  if (slide?.exportId) {
    return `export:${slide.exportId}`;
  }
  if (slide?.url) {
    return `url:${slide.url}`;
  }
  return `slide:${slide?.order ?? index}`;
}

// Ids must be unique for dnd-kit and React keys, even for duplicate or legacy slides.
export function getSlideIds(slides) {
  const seen = new Map();
  const used = new Set();
  return slides.map((slide, index) => {
    const base = getBaseSlideId(slide, index);
    let occurrence = (seen.get(base) || 0) + 1;
    let id = occurrence === 1 ? base : `${base}#${occurrence}`;
    while (used.has(id)) {
      occurrence += 1;
      id = `${base}#${occurrence}`;
    }
    seen.set(base, occurrence);
    used.add(id);
    return id;
  });
}

export function reorderSlides(slides, sourceIndex, destinationIndex) {
  return arrayMove(slides, sourceIndex, destinationIndex).map((slide, order) => ({ ...slide, order }));
}